import React from 'react';
import { motion } from 'framer-motion';
import { ShoppingCart, CheckCircle2 } from 'lucide-react';
import { KITS } from '../data/kits';
import { UPSELLS } from '../data/upsells';
interface CompleteCollectionProps {
  onBuyAll: () => void;
}
export function CompleteCollection({
  onBuyAll
}: CompleteCollectionProps) {
  const allProducts = [...KITS, ...UPSELLS];
  const totalValue = allProducts.reduce((sum, p) => sum + p.oldPrice, 0);
  const bundlePrice = 29990; // Example bundle price, adjust as needed or calculate
  const savings = totalValue - bundlePrice;
  return <section className="py-24 bg-ink text-white relative overflow-hidden" data-id="element-231">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-combo-green/20 via-transparent to-transparent opacity-50" data-id="element-232"></div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-233">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white text-ink rounded-[2rem] sm:rounded-[3rem] p-6 sm:p-10 lg:p-16 shadow-premium relative mt-4" data-id="element-234">
          <div className="absolute -top-3 sm:-top-4 left-1/2 -translate-x-1/2 lg:left-auto lg:right-12 lg:translate-x-0 lg:-translate-y-1/2 lg:top-0 bg-gold text-ink font-extrabold text-[11px] sm:text-sm px-4 sm:px-6 py-1.5 sm:py-2 rounded-full uppercase tracking-wider shadow-md whitespace-nowrap" data-id="element-235">
            LA OPCIÓN MÁS ELEGIDA
          </div>

          <div className="grid lg:grid-cols-2 gap-8 sm:gap-10 lg:gap-16 items-center mt-4 lg:mt-0" data-id="element-236">
            <div data-id="element-237">
              <div className="grid grid-cols-3 gap-2 sm:gap-3 mb-8" data-id="element-238">
                {allProducts.slice(0, 9).map((p, i) => <div key={i} className="aspect-[3/4] bg-cream rounded-xl p-3 flex items-center justify-center border border-ink/5 relative overflow-hidden group" data-id="element-239">
                    {p.image ? <img src={p.image} alt={p.name} className="w-full h-full object-contain drop-shadow-md group-hover:scale-110 transition-transform duration-500" data-id="element-240" /> : <div className="w-full h-full bg-white rounded shadow-sm" data-id="element-241"></div>}
                  </div>)}
              </div>
            </div>

            <div className="flex flex-col justify-center" data-id="element-242">
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold mb-8 tracking-tight leading-[1.1]" data-id="element-243">
                Todo lo que necesitás en un solo lugar.
              </h2>

              <ul className="space-y-4 mb-10" data-id="element-244">
                <li className="flex items-center gap-3 sm:gap-4 text-ink-light text-base sm:text-lg" data-id="element-245">
                  <CheckCircle2 className="w-5 h-5 sm:w-6 sm:h-6 text-combo-green flex-shrink-0" data-id="element-246" />
                  <span data-id="element-247">9 ebooks especializados</span>
                </li>
                <li className="flex items-center gap-3 sm:gap-4 text-ink-light text-base sm:text-lg" data-id="element-248">
                  <CheckCircle2 className="w-5 h-5 sm:w-6 sm:h-6 text-combo-green flex-shrink-0" data-id="element-249" />
                  <span data-id="element-250">Más de 360 recetas en total</span>
                </li>
                <li className="flex items-center gap-3 sm:gap-4 text-ink-light text-base sm:text-lg" data-id="element-251">
                  <CheckCircle2 className="w-5 h-5 sm:w-6 sm:h-6 text-combo-green flex-shrink-0" data-id="element-252" />
                  <span data-id="element-253">Todos los bonos incluidos</span>
                </li>
              </ul>

              <div className="bg-cream p-5 sm:p-8 rounded-[1.5rem] sm:rounded-[2rem] mb-8 sm:mb-10 border border-combo-green/20 relative overflow-hidden" data-id="element-254">
                <div className="absolute top-0 right-0 w-32 h-32 bg-combo-green/5 rounded-bl-full" data-id="element-255"></div>
                <div className="relative z-10" data-id="element-256">
                  <div className="flex justify-between items-center gap-3 mb-3" data-id="element-257">
                    <span className="text-xs sm:text-sm font-bold text-ink-light uppercase tracking-wider" data-id="element-258">
                      Valor total
                    </span>
                    <span className="text-lg sm:text-xl text-ink-light line-through decoration-red-500/50 tabular-nums" data-id="element-259">
                      ${totalValue.toLocaleString('es-AR')}
                    </span>
                  </div>
                  <div className="flex justify-between items-center gap-3" data-id="element-260">
                    <span className="text-xs sm:text-sm font-bold text-ink uppercase tracking-wider" data-id="element-261">
                      Precio oferta
                    </span>
                    <span className="text-4xl sm:text-5xl font-extrabold text-combo-green tabular-nums whitespace-nowrap" data-id="element-262">
                      ${bundlePrice.toLocaleString('es-AR')}
                    </span>
                  </div>
                </div>
              </div>

              <button onClick={onBuyAll} className="w-full bg-combo-green text-white py-4 sm:py-6 px-4 rounded-full font-bold text-base sm:text-lg lg:text-xl hover:bg-combo-green/90 transition-all shadow-premium hover:shadow-premium-hover hover:-translate-y-1 flex items-center justify-center gap-2 sm:gap-3" data-id="element-263">
                <ShoppingCart className="w-5 h-5 sm:w-6 sm:h-6 flex-shrink-0" data-id="element-264" />
                <span data-id="element-265">QUIERO EL PACK COMPLETO</span>
              </button>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}